import { Grid } from '@material-ui/core';
import { PaginationNumbers, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { getFormationsMap } from '@webapps/business';
import { useStyles } from '@webapps/styles';

import TrainingCard from './TrainingCard';
import { useState } from 'react';
import { useFormik } from 'formik';
import FiltersTraining from './FiltersTraining';
import Nodata from 'components/NoData';
import theme from '../theme';

const Trainings = ({ relations }) => {
  const { classes, global, theme: { spacing } } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    images: { TrainingsWithSheets }
  } = theme

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);

  const formik = useFormik({
    initialValues: {
      keyword: '',
      cfa: {
        id: '',
      },
    },
  });

  const { data: { content: trainings = {}, totalElements } = {}, refetch, isLoading } = useQuery(getFormationsMap, {
    key: ['formationsMap', idUser, page, size, formik?.values],
    variables: {
      keyword: formik?.values?.keyword,
      cfas: formik?.values?.cfa?.id,
      schools: idUser,
      page: page - 1,
      size,
      trainingTypes: 'Alternance'
    },
    keepPreviousData: true,
  });

  return (
    <div className={classes.container}>
      <FiltersTraining formik={formik} cfas={relations.map(relation => relation.cfa)} />
      <Grid container className={global.paper}>
        {isLoading ? (
          <>
            {[...Array(size/2)].map((_, idx) => (
              <Grid item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }} key={idx}>
                <TrainingCard key={idx} isLoading={true} />
              </Grid>
            ))}
          </>
        ) : trainings.length > 0 ? trainings.map(item => (
          <Grid key={item.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }}  >
            <TrainingCard item={item} cfas={relations.map(relation => relation.cfa)} refetch={refetch} />
          </Grid>
        )) : (
          <Grid item xs={12} className={classes.noDataContainer}>
            <Nodata
              image={TrainingsWithSheets}
              contentWidth='70%'
              padding='0px 20px 20px 0px'
              title="Aucune formation trouvée"
              description="Aucune formation en alternance n'a été trouvée pour les CFAs avec lesquels vous êtes en relation."
            />
          </Grid>
        )}
      </Grid>
      {!isLoading && trainings.length > 0 && totalElements > size && (
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background: 'white',
    height: '100%',
    borderRadius: '0 0 10px 10px',
  },
  noDataContainer: {
    padding: '20px',
    width: '100%',
    height: '100%',
  }
});

export default Trainings;
